module.exports = __webpack_public_path__ + "img/tr.c6769b52.svg";